module.exports = __webpack_public_path__ + "static/media/conversation.95f74f37.svg";